import { format } from 'date-fns';

function transformKeys(data, dt, pkg) {
  const array = [];
  for (let i = 0; i < data.length; i++) {
    let curr = data[i];
    let obj = {};

    obj['policyDate'] = dt !== undefined ? format(dt, 'dd/MM/yyyy') : format(new Date('dd/MM/yyyy'));
    obj['pkg'] = pkg;
    array.push({ ...curr, ...obj });
  }
  return array;
}

export default transformKeys;
